// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-container[data-v-4289de3c]{background-color:#fff;width:96%;height:102%;padding:20px;padding-top:10px}", ""]);
// Exports
module.exports = exports;
